import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./LoginPage";
import IFrameAuthListener from "./IFrameAuthListener";
import RouteErrorPage from './RouteErrorPage';
import Cookies from 'js-cookie';
import {
  allowedStandardDomains,
  getClientSubdomain,
  checkHasPermissionToShippingApp,
  checkHasPermissionToAssessmentManagerApp,
  checkHasPermissionToQuestCodesApp,
  checkHasPermissionToAssetManagerApp
} from "./utils";

// import useMe from './hooks/useMe';
// import useDataVerify from './dataHooks/useDataVerify';
// import useDataMe from './dataHooks/useDataMe';

const PrivateRoute = ({ element: Component, ...routeProps }) => {
  // const { isVerified, hasShippingAppAccess, hasAssessmentAppAccess, hasQuestCodesAppAccess } = useMe()
  // TODO: This should be eventually made more secure by being a token that will be sent to the backend
  // which can confirm its a cookie generated by us

  // Alternatively we may be able to use this same cookie, but make sure it is set to httpOnly / secure
  // This would mean however it cant be accessed by the javascript here below so we would need to make a dedicated API
  // endpoint to check if this cookie exists here and return true or false

  // Check for app level permissions and redirect to the login page if user does not have proper permissions

  // Update future check to be example:
  // if ((path === 'shipping') && !hasShippingAppAccess) return <LoginPage />

  const { path } = routeProps
  if ((path === 'shipping') && !checkHasPermissionToShippingApp()) return <LoginPage />
  if ((path === 'assessmentManager') && !checkHasPermissionToAssessmentManagerApp()) return <LoginPage />
  if ((path === 'questCodes') && !checkHasPermissionToQuestCodesApp()) return <LoginPage />
  if ((path === 'assetManager') && !checkHasPermissionToAssetManagerApp()) return <LoginPage />

  const clientSubdomain = getClientSubdomain()
  const isAllowedDomain = allowedStandardDomains.indexOf(clientSubdomain) > -1;

  const isAuthorizedCookie = Cookies.get('isAuthorized');

  // Run special logic on this path since its meant to be used as an IFrame in the Quest portal
  if (path === 'questAssessmentDashboard') {
    const isQuestAssessmentDashboardAuthorized = (sessionStorage.getItem('isQuestAssessmentDashboardAuthorized') === 'true');
    const hasAssessmentManagerPerms = checkHasPermissionToAssessmentManagerApp();
    if (hasAssessmentManagerPerms || isQuestAssessmentDashboardAuthorized) {
      return <Component {...routeProps} />
    } else {
      return <IFrameAuthListener />
    }
  }

  return (isAllowedDomain && isAuthorizedCookie && isAuthorizedCookie === 'true') ? <Component {...routeProps} /> : <LoginPage />;
};

const PublicRoute = ({ element: Component, ...routeProps }) => {
  return <Component {...routeProps} />;
};

export default ({
  routes = []
}) => {

  // Upcoming jwt logic
  // const { getIsVerified } = useDataVerify()
  // const { fetchMe } = useDataMe()

  // const verifyLoader = async () => {
  //   const isVerified = await getIsVerified()
  //   const me = await fetchMe()
  //   return { ...me, isVerified }
  // };

  // const publicLoader  = async () => {
  //   const me = await fetchMe()
  //   return me;
  // }

  const parseRoute = (route) => {
    return route.map((routeObj) => {
      const {
        path,
        isPrivate,
      } = routeObj;
      const parsedRouteObj = { ...routeObj }
      if (path === '/') {
        parsedRouteObj.errorElement = <RouteErrorPage />;
      }

      if (isPrivate) {
        parsedRouteObj.element = <PrivateRoute {...routeObj} />;
        // parsedRouteObj.loader = verifyLoader;
      } else {
        parsedRouteObj.element = <PublicRoute {...routeObj} />;
        // parsedRouteObj.loader = publicLoader;
      }
     // parsedRouteObj.shouldRevalidate = () => true;
      
      return parsedRouteObj
    })
  }

  const router = createBrowserRouter(parseRoute(routes));

  return <RouterProvider router={router} />
}